/** Legacy DB rows use `variant`; schema enum is `variable`. */
export function isVariableProductType(productType?: string): boolean {
  return productType === 'variable' || productType === 'variant';
}

export function productHasVariants(product: {
  productType?: string;
  variants?: unknown[];
  variantConfig?: { hasSizes?: boolean; hasColors?: boolean };
}): boolean {
  if (isVariableProductType(product.productType)) return true;
  if ((product.variants?.length ?? 0) > 0) return true;
  if (product.variantConfig?.hasSizes || product.variantConfig?.hasColors) return true;
  return false;
}
